<div class="previous-step">
  <span [innerHTML]="'m/task-process/selected-name' | translate: { name: selectedTemplate.name }"></span>

  <ion-button (click)="changeTemplate()" size="small" fill="clear">
    <span>{{ 'common/change' | translate }}</span>
  </ion-button>
</div>

<div class="previous-step parameters" *ngIf="chooseTemplateFlowService.hasParameters">
  <span [innerHTML]="'m/task-process/message-parameters' | translate"></span>

  <ion-button (click)="back()" size="small" fill="clear">
    <span>{{ 'common/change' | translate }}</span>
  </ion-button>
</div>

<div class="message-preview">
  <ng-container
    [ngSwitch]="taskProcessContext.engagement ? engagementService.strategy.channelType : SiteTypeEnum.WhatsApp">
    <ng-container *ngSwitchCase="SiteTypeEnum.WhatsApp">
      <app-whatsapp-template-preview [templateDisplayedBS]="chooseTemplateFlowService.templateDisplayedBS">
      </app-whatsapp-template-preview>
    </ng-container>
    <ng-container *ngSwitchCase="SiteTypeEnum.Kakaotalk">
      <app-kakaotalk-template-preview [templateDisplayedBS]="chooseTemplateFlowService.templateDisplayedBS">
      </app-kakaotalk-template-preview>
    </ng-container>
  </ng-container>

  <ng-template #whatsappTemplateMode>
    <app-whatsapp-template-preview [templateDisplayedBS]="chooseTemplateFlowService.templateDisplayedBS">
    </app-whatsapp-template-preview>
  </ng-template>

  <ng-content></ng-content>
</div>
